import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Layouts
import { LayoutComponent } from '@layout/layout.component';
import { PublicLayoutComponent } from '@shared/layout/components/public/public-layout/public-layout.component';

// Components
import { NotFoundComponent } from '@shared-components/not-found-component/not-found.component';

// Guards
import { AuthGuard } from '@auth/guard/auth.guard';
import { PermissionGuard } from '@auth/guard/permission.guard';

const routes: Routes = [
  {
    path: 'sistema',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },

      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboards/dashboards.module').then((m) => m.DashboardsModule),
        data: { breadcrumb: 'Dashboard' },
      },
      {
        path: 'actas', // Gestión interna de actas
        loadChildren: () => import('./actas/actas.module').then((m) => m.ActasModule),
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./usuarios/usuarios.module').then((m) => m.UsuariosModule),
      },
      {
        path: 'configuracion',
        loadChildren: () => import('./sistema/sistema.module').then((m) => m.SistemaModule),
      },
      {
        path: 'reportes',
        loadChildren: () => import('./reportes/reportes.module').then((m) => m.ReportesModule),
      },
      {
        path: 'juzgamiento',
        loadChildren: () =>
          import('./juzgamiento/juzgamiento.module').then((m) => m.JuzgamientoModule),
      },
      {
        path: 'pagos-recaudacion',
        loadChildren: () =>
          import('./pagos-recaudacion/pagos-recaudacion.module').then(
            (m) => m.PagosRecaudacionModule,
          ),
      },
      {
        path: 'import-pagos-recaudacion',
        loadChildren: () =>
          import('./import-pagos-recaudacion/import-pagos-recaudacion.module').then(
            (m) => m.ImportPagosRecaudacionModule,
          ),
      },

      {
        path: 'tipos-equipos',
        loadChildren: () =>
          import('./tipos-equipos/tipos-equipos.module').then((m) => m.TiposEquiposModule),
      },
      // Pantalla anterior, reemplazada por equipos-medicion: los links guardados siguen andando.
      { path: 'administracion-equipos', redirectTo: 'equipos-medicion', pathMatch: 'full' },
      {
        path: 'equipos-medicion',
        loadChildren: () =>
          import('./equipos-medicion/equipos-medicion.routes').then(
            (m) => m.EQUIPOS_MEDICION_ROUTES,
          ),
      },
      {
        path: 'dispositivos',
        loadChildren: () =>
          import('./dispositivos/dispositivos.module').then((m) => m.DispositivosModule),
      },
      {
        path: 'nomencladores',
        loadChildren: () =>
          import('./nomencladores/nomencladores.module').then((m) => m.NomencladoresModule),
      },
      {
        path: 'recursos',
        loadChildren: () => import('./recursos/recursos.module').then((m) => m.RecursosModule),
      },
      {
        path: 'inspectores',
        loadChildren: () =>
          import('./inspectores/inspectores.module').then((m) => m.InspectoresModule),
      },
      {
        path: 'notificaciones',
        loadChildren: () =>
          import('./notificaciones/notificaciones.module').then((m) => m.NotificacionesModule),
      },
      {
        path: 'relacion-gestor-juez',
        loadChildren: () =>
          import('./grupos/relacion-entidades.module').then((m) => m.RelacionEntidadesModule),
        data: { breadcrumb: 'Relación Gestor-Juez' },
      },
      {
        path: 'canchones',
        loadChildren: () => import('./canchones/canchones.module').then((m) => m.CanchonesModule),
      },
      {
        path: 'gruas',
        loadChildren: () => import('./gruas/gruas.module').then((m) => m.GruasModule),
      },
      {
        path: 'retenciones',
        loadChildren: () =>
          import('./retenciones-licencias/retenciones-routing.module').then(
            (m) => m.RETENCIONES_ROUTES,
          ),
      },
      {
        path: 'licencias',
        canActivate: [PermissionGuard],
        data: { permission: 'licencias:consultar' },
        loadChildren: () => import('./licencias/licencias.routes').then((m) => m.LICENCIAS_ROUTES),
      },
      // todo faltan modulos capazssh
    ],
  },
  /*{
    path: '',
    pathMatch: 'full',
    component: NotFoundComponent,
  },*/
  {
    path: '',
    component: PublicLayoutComponent,
    loadChildren: () => import('./portal/portal.module').then((m) => m.PortalModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
